import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: 0, // 0 par défaut, 1 pour le mode spécifique
};

const botSlice = createSlice({
  name: "mode",
  initialState,
  reducers: {
    setMode: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const { setMode } = botSlice.actions;
export default botSlice.reducer;
